import { render, staticRenderFns } from "./CargoExpenseCreate.vue?vue&type=template&id=1b0def4e&scoped=true"
import script from "./CargoExpenseCreate.vue?vue&type=script&lang=js"
export * from "./CargoExpenseCreate.vue?vue&type=script&lang=js"
import style0 from "./CargoExpenseCreate.vue?vue&type=style&index=0&id=1b0def4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0def4e",
  null
  
)

export default component.exports